import * as React from 'react';
import { useState, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Button } from 'components/bootstrap';
import AddCollectionFormGroup from 'collections/components/AddCollectionFormGroup';
import { createGRN, getValuesFromGRN } from 'logic/permissions/GRN';
import useEntityMembershiPolicies from 'collections/hooks/useEntityMembershipPolicies';
import { Spinner } from 'components/common';

type Props = {
  onSubmit: (collectionids: Array<string>) => void;
  entityId: string;
  entityType: string;
};

const SubmitButton = styled(Button)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.md};
    align-self: end;
  `,
);

const FormElements = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacings.md};
  `,
);
const Container = styled.div`
  flex: 1;
`;

const CollectionsSelector = ({ entityId, entityType, onSubmit }: Props) => {
  const {
    data: entityMembershipPolicies,
    isLoading: isLoadingEntityMembershipPolicies,
    refetch: refetchEntityMembershipPolicies,
  } = useEntityMembershiPolicies(entityId, entityType, { enabled: true });

  const [selectedcollectionsIds, setSelectedCollectionsIds] = useState<Array<string>>(null);
  const handleCollectionsChange = (value: { selected_collections: Array<string> }) => {
    const ids = value.selected_collections.map((c) => getValuesFromGRN(c).id);

    setSelectedCollectionsIds(ids);
  };

  const handleSubmit = () => {
    onSubmit(selectedcollectionsIds);
    refetchEntityMembershipPolicies();
  };
  const initialValue = useMemo(
    () => entityMembershipPolicies?.map((v) => createGRN('collection', v.target_id)),
    [entityMembershipPolicies],
  );

  if (isLoadingEntityMembershipPolicies) {
    return <Spinner />;
  }

  return (
    <FormElements>
      <Container>
        <AddCollectionFormGroup
          label="Add default collections"
          hideHelp
          filterValueFromOption
          entityType={entityType}
          onChange={handleCollectionsChange}
          overrideExclude
          value={initialValue}
        />
      </Container>

      <SubmitButton
        bsStyle="primary"
        disabled={!selectedcollectionsIds}
        onClick={handleSubmit}
        title="Add collection to default collections membership"
        type="button">
        Add collection
      </SubmitButton>
    </FormElements>
  );
};

export default CollectionsSelector;
